import { ReactElement } from 'react';
import RichText from 'components/UI/Richtext';
import { IComponentFormFields } from 'types/contentful';
import JotForm from './JotForm';

export default function Form({
  heading,
  copy,
  formId,
  formProvider,
  formAlignment,
}: IComponentFormFields): ReactElement {
  // If headerType is ECPRebranding only than add the styleclass
  // ecp-rebrand-header to the dummy layer
  if (formAlignment === 'center') {
    return (
      <div className="bg-neutral p-4 py-10 md:py-20 px-site-component">
        <h2 className="font-heading text-3xl md:text-4xl">{heading}</h2>
        <div className="mt-1 flex flex-col lg:flex-row">
          <div className="w-full mt-6 lg:mt-0 lg:w-5/5">
            <div className={`${formProvider === 'JotForm' ? 'mt-7' : ''}`}>
              <RichText document={copy} classNames="opacity-50" />
            </div>
          </div>
        </div>
        <div className="mt-1 flex flex-col lg:flex-row">
          <div className="w-full mt-6 lg:mt-0 lg:w-5/5">
            {formProvider === 'JotForm' && <JotForm title={heading} formId={formId} />}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="bg-neutral p-4 py-10 md:py-20 px-site-component">
        <h1 className="font-heading text-3xl md:text-4xl">{heading}</h1>
        <div className="mt-2 flex flex-col lg:flex-row">
          <div className="w-full lg:w-2/5">
            <div className={`${formProvider === 'JotForm' ? 'mt-10' : ''}`}>
              <RichText document={copy} classNames="opacity-50" />
            </div>
          </div>
          <div className="w-full mt-6 lg:mt-0 lg:w-3/5 lg:pl-10">
            {formProvider === 'JotForm' && <JotForm title={heading} formId={formId} />}
          </div>
        </div>
      </div>
    );
  }
}
